<template>
  <v-dialog v-model="dialog" width="500" scrollable>
    <template v-slot:activator="{ on }">
      <div v-if="isJob">
        <v-btn
          depressed
          v-on="on"
          v-if="!$route.meta.hideAction && (isAdmin || isDataEntry || isDataEntryAndDispatcher)"
          class="primary"
          tile
          :icon="is_mobile"
          color="white"
          :height="$root.dense ? '40px' : '56px'"
        >
          <span v-if="!is_mobile">
            ADD NEW
          </span>
          <v-icon v-else>
            mdi-plus
          </v-icon>
        </v-btn>
      </div>
      <div v-else v-on="on">
        <add-button v-if="!item.id"></add-button>
        <edit-icon-button v-else></edit-icon-button>
      </div>
    </template>
    <v-card>
      <v-card-title>
        {{ title }}
      </v-card-title>
      <v-card-text class="pb-0">
        <v-form ref="form" v-model="isValid">
          <v-text-field
            v-model="form.zipcode"
            label="Zip Code"
            dense
            outlined
            :rules="rules"
          ></v-text-field>
          <v-text-field
            v-model="form.community"
            label="Community"
            dense
            outlined
            :rules="rules"
          ></v-text-field>
          <v-text-field
            v-model="form.zone"
            label="Zone"
            dense
            outlined
            :rules="rules"
          ></v-text-field>
          <v-text-field
            v-model="form.price"
            label="Price ($)"
            dense
            type="number"
            outlined
            :rules="rules"
          ></v-text-field>
          <v-checkbox label="Do not service" v-model="form.is_donot">
          </v-checkbox>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red" @click="dialog = false">Cancel</v-btn>
        <v-btn text color="green" @click="submit()" v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"
          >Submit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { getDateTime, getFormDoc } from "../../assets/js/common";
import { zipcodes } from "../../assets/js/firebase";
import { FIELD } from "../../assets/js/rules";
import AddButton from "../buttons/AddButton.vue";
import EditIconButton from "../buttons/EditIconButton.vue";
export default {
  components: { AddButton, EditIconButton },
  props: {
    item: {
      type: Object,
      default: () => {
        return {};
      }
    },
    isJob: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isValid: false,
      dialog: false,
      form: {},
      rules: FIELD
    };
  },
  computed: {
    title() {
      return this.item.id ? "Edit Zip Code" : "Add New Zip Code";
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    init() {
      const vm = this;
      vm.form = {
        zipcode: "",
        community: "",
        is_donot: false,
        zone: "",
        price: ""
      };
      if (vm.item.id) {
        Object.keys(vm.form).forEach(key => {
          let val = vm.item[key];
          if (val !== undefined) vm.form[key] = val;
        });
      }
    },
    submit() {
      const vm = this;
      vm.$refs.form.validate();
      if (!vm.isValid) return;
      let doc = getFormDoc(vm.form);
      if (vm.item.id) {
        vm.update(doc);
      } else {
        vm.create(doc);
      }
    },
    async update(doc) {
      const vm = this;
      try {
        let { id } = vm.item;
        vm.$loader.show();
        let snap = await zipcodes
          .where("zipcode", "==", doc.zipcode)
          .where("community", "==", doc.community)
          .limit(1)
          .get();
        if (!snap.empty && snap.docs[0].id != id) {
          vm.$loader.hide();
          vm.$root.alert(
            "Another zipcode already exists with the same community. Please enter a unique community."
          );
          return;
        }
        doc.updated_at = getDateTime(new Date());
        await zipcodes.doc(id).update(doc);
        vm.dialog = false;
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$root.alert(error.message);
      }
    },
    async create(doc) {
      const vm = this;
      try {
        vm.$loader.show();
        let snap = await zipcodes
          .where("zipcode", "==", doc.zipcode)
          .where("community", "==", doc.community)
          .limit(1)
          .get();
        if (!snap.empty) {
          vm.$loader.hide();
          vm.$alert.show(
            "Another zipcode already exists with the same community. Please enter a unique community."
          );
          return;
        }
        doc.created_at = getDateTime(new Date());
        doc.updated_at = getDateTime(new Date());
        await zipcodes.add(doc);
        vm.dialog = false;
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.$alert.show(error.message);
      }
    }
  }
};
</script>

<style></style>
